import { createContext, useContext, type ReactNode } from 'react';
import type { ApiClient } from '@mrrmlab/api-client';

const ApiClientContext = createContext<ApiClient | null>(null);

export interface ApiClientProviderProps {
  client: ApiClient;
  children: ReactNode;
}

export function TrackingApiClientProvider({ client, children }: ApiClientProviderProps) {
  return <ApiClientContext.Provider value={client}>{children}</ApiClientContext.Provider>;
}

export function useApiClient(): ApiClient {
  const client = useContext(ApiClientContext);
  if (!client) {
    throw new Error(
      '[feature-tracking] useApiClient called outside <TrackingApiClientProvider>. ' +
        'Wrap your app with <TrackingApiClientProvider client={...}> once at the root.',
    );
  }
  return client;
}
